import React, { useMemo, useEffect, useState, useCallback } from "react";
import PageTitle from "../../../layouts/PageTitle";

import { useTable, useFilters, usePagination } from "react-table";
import "../../table/FilteringTable/filtering.css";
import axiosInstance from "../../../../services/AxiosInstance";
import { getDefaultParams } from "../../../../services/DefaultParamets";
import Tables from "../components/tables";
import SearchInput from "../components/input_search";
import { Link } from "react-router-dom";
import { Badge, ButtonGroup, Modal, Table, Button } from "react-bootstrap";
import {
  LinkPrimary,
  CitoPlusLinkIconPrimary,
  CitoPlusLinkIconDanger,
} from "../components/CitoPlusLink";
import ModalFormParqueadero from "./ModalParqueaderoForm";
import Swal from "sweetalert2";
import { notifySuccess, notifyError } from "../components/CitoPlusToastr";
import { toUpper } from "lodash";

export const Parqueaderos = () => {
  const [smallModalTitle, setSmallModalTitle] = useState("");
  const [smallModalBody, setSmallModalBody] = useState("");
  const [smallShowModal, setSmallShowModal] = useState(false);

  const [showHistorialModal, setShowHistorialModal] = useState(false);
  const [historialData, setHistorialData] = useState([]);
  const [selectedParqueaderoSlug, setSelectedParqueaderoSlug] = useState(null);

  const [loading, setLoading] = useState(true);

  const [data, setData] = useState([]);
  const [totalPages, setTotalPages] = useState(1);
  const [currentPage, setCurrentPage] = useState(1);
  const [searchValue, setSearchValue] = useState("");
  const [sortField, setSortField] = useState("");
  const [order, setOrder] = useState("asc");

  const [nextUrl, setNextUrl] = useState([]);
  const [previousUrl, setPreviousUrl] = useState([]);

  const URL = "/api/v3/parking/parqueaderos/";
  const titleCard = "Parqueaderos";

  const [defaultParams, setDefaultParams] = useState(getDefaultParams);

  const columns = useMemo(
    () => [
      {
        id: "no_parqueadero",
        Header: "# de Parqueadero",
        accessor: "no_parqueadero",
        disableFilters: true,
        disableSortable: false,
      },
      {
        id: "tipo_parqueadero",
        Header: "Tipo",
        disableFilters: true,
        disableSortable: false,
        accessor: (row) => {
          return (
            <>
              Tipo: <b>{row.tipo_parqueadero}</b> <br />
              Rotación:{" "}
              <b>{row.entra_en_rotacion ? "Rotación" : "No Rotación"}</b>
            </>
          );
        },
      },
      {
        id: "vehiculo",
        Header: "Vehículo",
        disableFilters: true,
        disableSortable: true,
        accessor: (row) => {
          return (
            <>
              <div className="left-align-cell">
                <p className="paragraph">
                  Estado:
                  <Badge
                    pill
                    bg={
                      row?.datos_parking?.vehiculo_estado === "entrada"
                        ? "success"
                        : row?.datos_parking?.vehiculo_estado === "salida"
                          ? "warning"
                          : "secondary"
                    }
                    className="ms-2"
                  >
                    {row?.datos_parking?.vehiculo_estado === "entrada"
                      ? "Ingreso"
                      : row?.datos_parking?.vehiculo_estado === "salida"
                        ? "Salida"
                        : toUpper(row?.datos_parking?.vehiculo_estado)}
                  </Badge>
                </p>
                <p className="paragraph">
                  Inmutable: {toUpper(row?.datos_parking?.inmueble)}
                </p>
                <p className="paragraph">
                  Placa: {toUpper(row?.datos_parking?.placa)}
                </p>
                <p className="paragraph">
                  Tipo: {toUpper(row?.datos_parking?.tipo_vehiculo)}
                </p>
                {row?.datos_parking?.marca !== null && (
                  <p className="paragraph">
                    Marca: {toUpper(row?.datos_parking?.marca)}
                  </p>
                )}
                {row?.datos_parking?.vehiculo_uuid && (
                  <button
                    className="btn btn-sm btn-primary mt-2"
                    onClick={() =>
                      handleOpenHistorialModal(
                        row.slug,
                        row.datos_parking.vehiculo_uuid,
                      )
                    }
                  >
                    Ver Historial
                  </button>
                )}
              </div>
            </>
          );
        },
      },
      {
        id: "estatus",
        Header: "Activo",
        accessor: "estatus",
        disableFilters: true,
        disableSortable: true,
        Cell: ({ value }) => {
          return (
            <Badge className="badge-light-primary" pill>
              {value ? "Activo" : "Inactivo"}
            </Badge>
          );
        },
      },
      {
        id: "acciones",
        Header: "Acciones",
        accessor: (row) => (
          <ButtonGroup aria-label="Botones de acciones">
            <CitoPlusLinkIconPrimary
              title="Editar"
              to={`#/${row.slug}`}
              onClick={() => {
                handleOpenModalForm(row.slug, true);
              }}
            >
              <i className="fas fa-pencil-alt"></i>
            </CitoPlusLinkIconPrimary>
            <CitoPlusLinkIconDanger
              title="Eliminar"
              to={`#/${row.slug}`}
              onClick={() => {
                handleEliminar(row.slug, false);
              }}
            >
              <i className="fas fa-trash"></i>
            </CitoPlusLinkIconDanger>
          </ButtonGroup>
        ),
        disableFilters: true,
        disableSortable: true,
      },
    ],
    [],
  );

  const debounce = (func, delay) => {
    let timeoutId;
    return function (...args) {
      clearTimeout(timeoutId);
      timeoutId = setTimeout(() => func(...args), delay);
    };
  };

  const debouncedfetchUrl = useCallback(
    debounce((pageIndex, search) => {
      fetchUrl(pageIndex, search);
    }, 500), // El valor 500 es el tiempo de espera en milisegundos
    [],
  );

  useEffect(() => {
    fetchUrl(1);
  }, []);

  const fetchUrl = async (pageIndex = 1, search = "", ordering = []) => {
    defaultParams.page = pageIndex;
    defaultParams.search = search;
    setLoading(true);
    try {
      if (pageIndex < 1 || pageIndex > totalPages) {
        setSmallModalTitle("Error de Página");
        setSmallModalBody("Error de Página");
        setSmallShowModal(true);
        return;
      }
      const response = await axiosInstance.get(URL, {
        params: {
          ...defaultParams,
          page: pageIndex,
          search: search,
          ordering: ordering,
        },
      });
      setNextUrl(response.data.next);
      setPreviousUrl(response.data.previous);
      setTotalPages(response.data.total_pages);
      setCurrentPage(response.data.current_page);
      setData(response.data.results);
    } catch (error) {
      console.error("Error fetching data:", error);
      if (error.response && error.response.status === 404) {
        setSmallModalTitle("Título del Modal");
        setSmallModalBody("Contenido del Modal");
        setSmallShowModal(true);
      } else {
        console.error("Error fetching data:", error);
      }
    } finally {
      setLoading(false);
    }
  };

  const handleSearchChange = (value) => {
    setSearchValue(value);
    setLoading(true);
    debouncedfetchUrl(1, value);
  };

  const handleEnterPress = () => {
    // Lógica para manejar la tecla Enter, si es necesario
  };

  const handleClearClick = () => {
    handleSearchChange("");
  };

  const handleSortingChange = (column) => {
    const { id } = column;

    const newOrder =
      sortField === id ? (order === "asc" ? "desc" : "asc") : "asc";

    setSortField(id);
    setOrder(newOrder);
    setLoading(true);
    fetchUrl(1, searchValue, `${newOrder === "desc" ? "-" : ""}${id}`);
  };

  const handleOpenModal = () => {
    setSmallShowModal(true);
  };

  const handleCloseModal = () => {
    setSmallShowModal(false);
  };

  const tableInstance = useTable(
    {
      columns,
      data,
      manualPagination: true,
      pageCount: totalPages,
    },
    useFilters,
    usePagination,
  );

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    prepareRow,
    state,
    page,
  } = tableInstance;

  // Modal de Agregar o editar Parqueadero
  const [showModalForm, setShowModalForm] = useState(false);
  const [selectedParqueaderoUUID, setSelectedParqueaderoUUID] = useState(null);
  const [editMode, setEditMode] = useState(false);

  const handleOpenModalForm = (selectedParqueaderoUUID, editMode) => {
    setShowModalForm(true);
    setSelectedParqueaderoUUID(selectedParqueaderoUUID);
    setEditMode(editMode);
  };

  const handleCloseModalForm = () => {
    setShowModalForm(false);
    setSelectedParqueaderoUUID(null);
    setEditMode(false);
  };
  // Fin Modal de Agregar o editar Parqueadero

  // Eliminar parqueadero
  const handleEliminar = (slug, editMode) => {
    Swal.fire({
      title: "¿Deseas eliminar este parqueadero?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Si, eliminar",
    }).then((result) => {
      if (result.isConfirmed) {
        axiosInstance
          .delete(`${URL}${slug}/`)
          .then((response) => {
            if (response.status === 204) {
              notifySuccess("Parqueadero eliminado correctamente");
              fetchUrl(1);
            }
          })
          .catch((error) => {
            console.error("Error fetching data:", error);
            if (error.response && error.response.status === 404) {
              notifyError("Página no encontrada");
            } else {
              notifyError("Error al eliminar parqueadero");
            }
          });
      }
    });
  };

  const handleOpenHistorialModal = async (parqueaderoSlug, vehiculoSlug) => {
    console.log(
      "Abriendo modal de historial para parqueadero:",
      parqueaderoSlug,
      "vehiculo:",
      vehiculoSlug,
    );
    try {
      const response = await axiosInstance.get(
        `${URL}${parqueaderoSlug}/vehiculo-historial/`,
      );
      console.log("Respuesta de API:", response.data);
      setHistorialData(response.data);
      setSelectedParqueaderoSlug(parqueaderoSlug);
      setShowHistorialModal(true);
      console.log("Modal abierto");
    } catch (error) {
      console.error("Error fetching historial:", error);
      notifyError("Error al cargar el historial");
    }
  };

  return (
    <>
      <div className="d-flex aling-items-center mb-4 flex-wrap">
        <h4 className="card-title">Parqueaderos</h4>
        <LinkPrimary
          to={`#`}
          className="ms-auto"
          onClick={() => {
            handleOpenModalForm(null, false);
          }}
        >
          <i className="fas fa-plus me-2"></i>
          Crear Parqueadero
        </LinkPrimary>
      </div>
      <div className="card">
        <div className="card-header">
          <div className="card-tools">
            <SearchInput
              value={searchValue}
              onSearchChange={handleSearchChange}
              onEnterPress={handleEnterPress}
              onClearClick={handleClearClick}
            />
          </div>
        </div>
        <div className="card-body">
          {loading ? (
            <p>Cargando...</p>
          ) : data.length === 0 ? (
            <p>No hay datos disponibles.</p>
          ) : (
            <Tables
              columns={columns}
              data={data}
              loading={loading}
              totalPages={totalPages}
              currentPage={currentPage}
              fetchUrl={fetchUrl}
              handleSortingChange={handleSortingChange}
              nextUrl={nextUrl}
              previousUrl={previousUrl}
              sortField={sortField}
              order={order}
              page={page}
            />
          )}
        </div>
      </div>

      <div>
        {/* Modal de Agregar o editar Parqueadero */}
        <ModalFormParqueadero
          showModal={showModalForm}
          onClose={handleCloseModalForm}
          updateList={fetchUrl}
          selectedParqueaderoUUID={selectedParqueaderoUUID}
          editMode={editMode}
        />
        {/* Fin Modal de Agregar o editar Parqueadero */}

        {/* Modal de Historial de Vehículo */}
        <Modal
          show={showHistorialModal}
          onHide={() => setShowHistorialModal(false)}
          size="lg"
        >
          <Modal.Header closeButton>
            <Modal.Title>Historial del Vehículo</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {historialData.length > 0 ? (
              <Table striped bordered hover>
                <thead>
                  <tr>
                    <th>Estado</th>
                    <th>Fecha</th>
                    <th>Vigilante</th>
                    <th>Placa</th>
                  </tr>
                </thead>
                <tbody>
                  {historialData.map((item) => (
                    <tr key={item.slug}>
                      <td>{item.estado}</td>
                      <td>{item.created_at}</td>
                      <td>{item.vigilante_nombre}</td>
                      <td>{item.vehiculo_placa}</td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            ) : (
              <p>No hay historial disponible.</p>
            )}
          </Modal.Body>
          <Modal.Footer>
            <Button
              variant="secondary"
              onClick={() => setShowHistorialModal(false)}
            >
              Cerrar
            </Button>
          </Modal.Footer>
        </Modal>
        {/* Fin Modal de Historial de Vehículo */}
      </div>
    </>
  );
};

export default Parqueaderos;
